import {
  AnimatePresence,
  type MotionNodeAnimationOptions,
  motion,
} from "motion/react";
import { AcceptedPaymentTypes } from "../../components/accepted-payment/AcceptedPaymentTypes";
import { CalculatorAside } from "../../components/calculator-aside/CalculatorAside";
import { CalculatorCustom } from "../../components/calculator-custom/CalculatorCustom";
import { CalculatorDialogs } from "../../components/calculator-dialogs/CalculatorDialogs";
import { CalculatorEnterprise } from "../../components/calculator-enterprise/CalculatorEnterprise";
import { CalculatorPack } from "../../components/calculator-pack/CalculatorPack";
import { CalculatorPaymentBtn } from "../../components/calculator-payment-btn/CalculatorPaymentBtn";
import { CalculatorCustomToggle } from "../../components/calculator-toggle/CalculatorToggle";
import { useCalculator } from "../../hooks/useCalculator";
import styles from "./CalculatorDefault.module.css";

export const CalculatorDefault = () => {
  return (
    <>
      <div className={styles.layout}>
        <AnimatePresence initial={false}>
          <Calculator key="calculator" />
        </AnimatePresence>

        <AcceptedPaymentTypes />
      </div>

      <CalculatorDialogs />
    </>
  );
};

const animation: MotionNodeAnimationOptions = {
  initial: {
    opacity: 0,
    translateX: 24,
  },
  animate: {
    opacity: 1,
    translateX: 0,
  },
  exit: {
    opacity: 0,
    translateX: -24,
  },
  transition: {
    duration: 0.3,
    ease: "easeIn",
  },
};

const Calculator = () => {
  const isCustomActive = useCalculator((state) => state.isCustomActive);

  return (
    <motion.div className={styles.body} {...animation}>
      <AnimatePresence initial={false}>
        {isCustomActive === false && <Packs key="packs" />}
        {isCustomActive === true && <Custom key="custom" />}
      </AnimatePresence>

      <CalculatorAside className={styles.aside} />

      <CalculatorPaymentBtn className={styles.btn} />
    </motion.div>
  );
};

const Packs = () => {
  const packs = useCalculator((state) => state.packs);

  return (
    <motion.div className={styles.packs} {...animation}>
      <AnimatePresence initial={false}>
        {packs.map((pack) => (
          <CalculatorPack key={pack.id} pack={pack} />
        ))}
      </AnimatePresence>
      <CalculatorCustomToggle className={styles.customToggle} />
      <CalculatorEnterprise className={styles.enterprise} />
    </motion.div>
  );
};

const Custom = () => {
  return (
    <motion.div className={styles.custom} {...animation}>
      <CalculatorCustom />
    </motion.div>
  );
};
